import { render, staticRenderFns } from "./SupplyDemand.vue?vue&type=template&id=5b538b3c&scoped=true&"
import script from "./SupplyDemand.vue?vue&type=script&lang=js&"
export * from "./SupplyDemand.vue?vue&type=script&lang=js&"
import style0 from "./SupplyDemand.vue?vue&type=style&index=0&id=5b538b3c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b538b3c",
  null
  
)

export default component.exports